module.exports = __webpack_public_path__ + "static/media/shadow-v4.0fc5b9db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/shadow-v4.svg
// module id = 89
// module chunks = 0